import React, { useState } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { COMPANY_DATA, NAVBAR_DATA } from "data";
import { handleClickScroll } from "utils";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [companyName] = useState(COMPANY_DATA.name.split(/(?=[A-Z])/));

  const handleNav = () => {
    setNav(!nav);
  };

  const onClickNavItem = (item) => {
    handleClickScroll(item);
    setNav(false);
  };

  return (
    <div className="flex justify-between items-center h-24 max-w-[1240px] mx-auto px-4 text-white">
      <Link to="/">
        <div className="flex cursor-pointer">
          <h1 className="w-full text-3xl font-bold text-white">
            {companyName[0]}
          </h1>
          <h1 className="w-full text-3xl font-bold text-[#00df9a]">
            {companyName[1]}
          </h1>
        </div>
      </Link>
      <ul className="hidden md:flex">
        {NAVBAR_DATA.map((item) => (
          <Link
            key={item.id}
            className="p-4 cursor-pointer"
            to={"/"}
            onClick={() => handleClickScroll(item.scrollTo.toLowerCase())}
            state={{ scrollTo: item.scrollTo.toLowerCase() }}
          >
            <li>{item.name}</li>
          </Link>
        ))}
      </ul>
      <div onClick={handleNav} className="block md:hidden">
        {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
      </div>
      <ul
        className={
          nav
            ? "fixed left-0 top-0 w-[60%] h-full border-r border-r-gray-900 bg-[#000300] ease-in-out duration-500"
            : "ease-in-out duration-500 fixed left-[-100%]"
        }
        onBlur={() => setNav(false)}
      >
        <h1 className="w-full text-3xl font-bold text-[#00df9a] m-4">
          {COMPANY_DATA.name}
        </h1>
        {NAVBAR_DATA.map((item, idx) =>
          idx === NAVBAR_DATA.length - 1 ? (
            <Link
              to={"/"}
              key={item.id}
              onClick={() => onClickNavItem(item.scrollTo.toLowerCase())}
              state={{ scrollTo: item.scrollTo.toLowerCase() }}
            >
              <li className="p-4 cursor-pointer">{item.name}</li>
            </Link>
          ) : (
            <Link
              to={"/"}
              key={item.id}
              onClick={() => onClickNavItem(item.scrollTo.toLowerCase())}
              state={{ scrollTo: item.scrollTo.toLowerCase() }}
            >
              <li className="p-4 border-b border-gray-600 cursor-pointer">
                {item.name}
              </li>
            </Link>
          )
        )}
      </ul>
    </div>
  );
};

export default Navbar;
